'use client';

import React from 'react';

const ShopPage: React.FC = () => {
  return (
    <section
      style={{
        padding: '5rem 1.25rem',
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <h2 className="section-title" style={{ fontFamily: "'Playfair Display', serif" }}>
        Tutoring Packages &amp; Resources
      </h2>
      <div className="gold-line" />

      {/* Coming Soon */}
      <div
        style={{
          background: 'rgba(244,196,48,0.08)',
          border: '1px solid rgba(244,196,48,0.3)',
          borderRadius: 12,
          padding: '2.5rem 1.5rem',
          maxWidth: 520,
          width: '100%',
          marginTop: '2rem',
        }}
      >
        <div
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '1.1rem',
            fontWeight: 700,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            color: '#f4c430',
            marginBottom: '0.5rem',
          }}
        >
          🚧 Coming Soon
        </div>
        <p
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '0.95rem',
            color: 'rgba(255,255,255,0.65)',
            lineHeight: 1.6,
            margin: 0,
          }}
        >
          Our shop is currently under construction. Check back soon for tutoring packages &amp; resources!
        </p>
      </div>
    </section>
  );
};

export default ShopPage;
